<template>
    <div class="container">
        <div class="row">
            <div class="col-xl-4 col-12 mb-3">
                <div class="card">
                    <div class="card-header blue-gradient">Agrega una dependencia a una zona</div>
                    <div class="card-body">
                        <div class="form-group">
                            <label for="name">Organización</label>
                            <select class="form-control" name="" id="" @change="fetchZones">
                                <option v-for="city in cities" :value="city.id" :key="city.id">{{city.name}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="name">Zona</label>
                            <select class="form-control" name="" id="" @change="fetchZoneEntities" v-model="attachment.zone_id">
                                <option v-for="(zone, i) in zones" :value="zone.id" :key="zone.id" :data-index="i">{{zone.name}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="name">Dependencia</label>
                            <select class="form-control" name="" id="" v-model="attachment.entity_id">
                                <option v-for="entity in entities" :value="entity.id" :key="entity.id">{{entity.name}}</option>
                            </select>
                        </div>
                        <input class="btn btn-primary" type="button" value="Asociar" @click="attach">
                    </div>
                </div>
            </div>
            <div class="col-xl-8 col-12">
                <div class="card">
                    <div class="card-header green-gradient">Dependencias de la zona {{selectedZone.name}} {{selectedZone.city}} </div>
                    <div class="card-body">
                        <table class="table table-stripped text-center" id="cities-table">
                            <thead>
                                <tr>
                                    <th>Nombre</th>
                                    <th>Usuario</th>
                                    <th>Teléfono</th>
                                    <th>Desasociar</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(entity, i) in zoneEntities" :key="entity.id">
                                    <td>{{entity.name}}</td>
                                    <td>{{entity.email}}</td>
                                    <td>{{entity.phone_number}}</td>
                                    <td><input type="button" value="✕" class="btn btn-danger btn-sm" @click="detach(entity, i)"></td>
                                </tr>
                                <tr v-if="zoneEntities.length==0">
                                    <td colspan="4" class="text-center">No hay dependencias para la zona seleccionada</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>
<script>
export default {
    name: "entity-zone",
    mounted: function(){
        this.fetchCities();
        this.fetchEntities();
    },
    data(){
        return {
            baseUrl: process.env.VUE_APP_API,
            cities: [],
            zoneEntities: [],
            selectedZone: {name:"", city:""},
            zones: [],
            entities: [],
            attachment: {
                zone_id: 0,
                entity_id: 0,
            }
            
        }
    },
    methods: {
        fetchCities: function(){
            let _this = this;
            this.$http
            .get(`${this.baseUrl}/public/cities`)
            .then(data => {
                _this.cities = data.body.data;
                _this.cities.unshift({id: "", name: "Seleccione una organización"});

            })
            .catch(error => {
                console.log(error.error);
            });
        },
        fetchEntities: function(){
            let _this = this;
            let loader = this.$loading.show();
            this.$http.get(`${this.baseUrl}/admin/entities`,
                {headers: {Authorization: `Bearer ${localStorage.getItem('session_id')}`}})
            .then(data => {
                _this.entities = data.body.data;
                _this.entities.unshift({id: "", name: "Seleccione una dependencia"});
                loader.hide();
            })
            .catch(error => {
                console.log(error.error);
                loader.hide();
            });
        },
        fetchZoneEntities: function(e){
            let zone_id = e.target.value;
            let index = e.target.options[e.target.selectedIndex].getAttribute('data-index');

            this.selectedZone = index >= 1 ? this.zones[index] : "";

            if(zone_id == 0 || zone_id == ""){
                this.zoneEntities = [];
                return;
            }

            let loader = this.$loading.show();

            let _this = this;
            this.$http
            .get(`${this.baseUrl}/public/zones/${zone_id}/entities`)
            .then(data => {
                _this.zoneEntities = data.body.data;
                loader.hide();

            })
            .catch(error => {
                console.log(error.error);
                loader.hide();

            });
        },
        fetchZoneEntitiesFromId: function(zone_id){
            if(zone_id == 0){
                return;
            }
            let loader = this.$loading.show();

            let _this = this;
            this.$http
            .get(`${this.baseUrl}/public/zones/${zone_id}/entities`)
            .then(data => {
                _this.zoneEntities = data.body.data;
                console.log(_this.zoneEntities);                
                loader.hide();

            })
            .catch(error => {
                console.log(error.error);                
                loader.hide();
            });
        },
        fetchZones: function(e){
            var city_id = e.target.value;

            if(city_id == 0){
                this.$dialogs.alert("Debe seleccionar una organización", {title: 'Error', size: 'sm'});
                this.zones = [];
                return;
            }

            let loader = this.$loading.show();
            let _this = this;
            this.$http
            .get(`${this.baseUrl}/public/cities/${city_id}/zones`)
            .then(data => {
                _this.zones = data.body.data;
                _this.zones.unshift({id: "", name: "Seleccione zona"});
                loader.hide();
            })
            .catch(error => {
                console.log(error.error);                
                loader.hide();

            });
        },
        attach(){
            let entity_id = this.attachment.entity_id;
            let zone_id = this.attachment.zone_id;
            let _this = this;


            if(zone_id != "" && zone_id != 0 && entity_id != "" && entity_id){
                let loader = this.$loading.show();
                this.$http.put(`${this.baseUrl}/admin/entities/${entity_id}/zones/${zone_id}`, {},
                {headers: {Authorization: `Bearer ${localStorage.getItem('session_id')}`}})
                .then(data => {
                    _this.$dialogs.alert("Asociación exitosa", {title: 'Éxito', size: 'sm'});
                    _this.fetchZoneEntitiesFromId(zone_id);
                    loader.hide();

                }).catch(error => {
                    console.log(error);
                    loader.hide();
                });
            } else {
                this.$dialogs.alert("Debe seleccionar una dependencia y una zona para asociar", {title: 'Error', size: 'sm'});
            }
        }, detach(entity, i){

            this.$dialogs.confirm(`¿Desea desasociar la dependencia ${entity.name} de la zona ${this.selectedZone.name} de ${this.selectedZone.city}?`, {title: "Desasociar", size: "sm", okLabel: "Sí", cancelLabel: "Cancelar"})
            .then(response => {
                if(response.ok){
                    const loader = this.$loading.show();
                    const requestUrl = `${this.baseUrl}/admin/entities/${entity.id}/zones/${this.selectedZone.id}`;
                    this.$http.delete(requestUrl,
                    {headers: {Authorization: `Bearer ${localStorage.getItem('session_id')}`}})
                    .then(data => {
                        this.$dialogs.alert("Dependencia desasociada con éxito", {title: "Éxito", size: "sm"});
                        this.zoneEntities.splice(i, 1);
                        loader.hide();
                    })
                    .catch(error => {
                        if(error.status == 409){
                            this.$dialogs.alert("No se puede desasociar la dependencia de esta zona", {title: "Error", size: "sm"});
                            loader.hide();
                        }
                    });
                }
            });
        }
    }
}
</script>
<style lang="sass" scoped>
    @import '../../assets/scss/colors';
</style>


